export const REVIEW_LABELS = [
  'Terrible',
  'Poor',
  'Average',
  'Good',
  'Excellent',
];
